import { configureRequest } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  ReassignItemRequestForAdminErrorResponse,
  ReassignItemRequestForAdminRequest,
  ReassignItemRequestForAdminSuccessResponse
} from './reassignItemRequestForAdmin.types'

export const reassignItemRequestForAdminApi = async (
  request: ReassignItemRequestForAdminRequest
): Promise<ReassignItemRequestForAdminSuccessResponse> => {
  const response = await configureRequest({
    url: urls.offers.reassignItemRequest,
    method: 'POST',
    params: {
      itemRequestId: request.itemRequestId
    },
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as ReassignItemRequestForAdminSuccessResponse
  } else {
    throw response as ReassignItemRequestForAdminErrorResponse
  }
}

export default reassignItemRequestForAdminApi
